<template>
  <div class="row">
    <modal :show.sync="modals">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Customer Details</h5>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-input
            label="Customer Name"
            type="email"
            placeholder="Customer Name"
            v-model="emp.fname"
          ></base-input>
          <base-input
            label="Password"
            type="email"
            placeholder="Password"
            v-model="emp.passwd"
          ></base-input>
          <base-input label="Department" type="text">
            <el-select
              class="select-default"
              size="large"
              placeholder="Choose..."
              v-model="emp.deptid"
            >
              <el-option
                v-for="dept in adminValue.deptList"
                :value="dept.DeptID"
                :label="dept.DeptName"
                :key="dept.DeptID"
              ></el-option>
            </el-select>
          </base-input>
          <base-input label="Designation" type="text">
            <el-select
              class="select-default"
              size="large"
              placeholder="Choose..."
              @change="checkDisable(currentRow)"
              v-model="emp.posid"
            >
              <el-option
                v-for="post in adminValue.postList"
                :value="post.PosID"
                :label="post.PosName"
                :key="post.PosID"
              ></el-option>
            </el-select>
          </base-input>
          <base-input label="Person In Charge">
            <el-select
              class="select-default"
              size="large"
              placeholder="Choose..."
              v-model="emp.managerid"
            >
              <el-option
                v-for="roles in adminValue.managerList"
                :value="roles.empid"
                :label="roles.empname"
                :key="roles.empid"
              ></el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-sm-6">
          <base-input
            label="Address"
            type="email"
            placeholder="Address"
            v-model="emp.addr"
          ></base-input>
          <base-input
            label="Telephone No"
            type="email"
            placeholder="Telephone No"
          ></base-input>
          <!-- <base-input label="Email" type="email" placeholder="Email" v-model="emp.email"></base-input> -->
          <base-input label="Status" type="text">
            <el-select
              class="select-default"
              size="large"
              placeholder="Choose..."
              v-model="emp.statid"
            >
              <el-option
                v-for="stat in adminValue.statList"
                :value="stat.StatusID"
                :label="stat.StatusName"
                :key="stat.StatusID"
              ></el-option>
            </el-select>
          </base-input>
          <base-input label="User role" type="text">
            <el-select
              class="select-default"
              size="large"
              placeholder="Choose..."
              v-model="emp.roleid"
            >
              <el-option
                v-for="roles in adminValue.rolesList"
                :value="roles.RoleID"
                :label="roles.RoleName"
                :key="roles.RoleID"
              ></el-option>
            </el-select>
          </base-input>
          <base-input label="Module access list" type="text">
            <el-select
              class="select-default"
              v-model="moduleaccess"
              multiple
              placeholder="Select"
            >
              <el-option
                v-for="item in moduleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>

      <div
        class="col-sm-12 d-flex justify-content-between"
        style="margin-top: 1%"
      >
        <base-button type="success" @click="submitUpdate(currentRow)"
          >Submit</base-button
        >
        <base-button type="warning" @click="modals = false">Cancel</base-button>
      </div>
    </modal>
    <div class="col-lg-8">
      <h2 class="inline">User Management</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-8">
              <h4 class="card-title">List of User</h4>
            </div>
            <div class="col-lg-4 text-right" style="margin-bottom: 1%">
              <base-button @click="addNewUser" round type="green">
                <i class="tim-icons icon-simple-add"></i>&nbsp;Add New User
              </base-button>
            </div>
          </div>
        </div>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <base-input label="rows visible">
              <el-select
                class="select-info mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="queriedData"
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column :min-width="135" align="right" label="Actions">
              <div slot-scope="props">
                <el-tooltip content="Edit" placement="bottom" effect="light">
                <base-button
                  @click.native="handleEdit(props.$index, props.row)"
                  class="edit btn-link"
                  type="info"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
                </el-tooltip>
                <el-tooltip content="Delete" placement="bottom" effect="light">
                <base-button
                  @click.native="handleDelete(props.$index, props.row)"
                  class="remove btn-link"
                  type="danger"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-simple-remove"></i>
                </base-button>
                </el-tooltip>
                <el-tooltip content="Revoke" placement="bottom" effect="light">
                <base-button
                  v-if="props.row.loginstate == 1"
                  @click.native="revokeSession(props.$index, props.row)"
                  class="remove btn-link"
                  type="danger"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-refresh-02"></i>
                </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination, Modal } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";

export default {
  components: {
    BasePagination,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },

  data() {
    return {
      allUsers: "",
      moduleaccess: [],
      moduleList: "",
      sorokRoot: "",
      allManager: "",
      modals: false,
      selects: {
        simple_site: "",
        site: [
          { value: "All", label: "All" },
          { value: "Klang Valley", label: "Klang Valley" },
          { value: "Klang Valley", label: "KLIA" }
        ]
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      emp: {
        statid: "",
        email: "",
        posid: "",
        fname: "",
        lname: "",
        passwd: "",
        roleid: "",
        deptid: "",
        managerid: ""
      },

      adminValue: {
        postList: "",
        statList: "",
        deptList: "",
        rolesList: "",
        managerList: ""
      },
      currentValue: {},
      searchQuery: "",
      propsToSearch: [
        "employeeID",
        "name",
        "department",
        "userRole",
        "userReportedTo",
        "position",
        "accesslist"
      ],
      tableColumns: [
        {
          prop: "employeeID",
          label: "Employee ID",
          minWidth: 150
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 150
        },

        {
          prop: "department",
          label: "department",
          minWidth: 150
        },
        {
          prop: "userRole",
          label: "User Role",
          minWidth: 150
        },
        {
          prop: "userReportedTo",
          label: "User Reported To",
          minWidth: 150
        }
      ],

      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: ""
    };
  },
  mounted() {
    this.getAllUsers();
    this.getDeptList();
    this.getRoleList();
    this.getPostList();
    this.getStatList();
    this.getManagerList();
    this.getModuleList();
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: [
        "employeeID",
        "name",
        "department",
        "userRole",
        "userReportedTo",
        "position",
        "accesslist"
      ],
      threshold: 0.3
    });
  },
  methods: {
    getModuleList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/module").then(res => {
        console.log(res);
        if (!res.error) {
          this.moduleList = res.message;
        } else {
        }

        console.log(this.deptList);
      });
    },
    addNewUser() {
      this.$router.push({ path: `/UserRegistration` });
    },
    checkDisable(id) {
      console.log("CALLED");
      console.log(this.emp.posid);
      //  console.log(this.adminValue.postList)
      this.adminValue.postList.map(a => {
        if (this.emp.posid == a.PosID) {
          console.log(a.PosName);
          if (a.PosName.toUpperCase().startsWith("CHIEF")) {
            this.adminValue.managerList = [];
            this.adminValue.managerList.push(this.sorokRoot);
            this.disablereport = true;
            this.emp.managerid = 1;
          } else if (a.PosName.toUpperCase().startsWith("HEAD")) {
            console.log("HIT");
            this.adminValue.managerList = [];
            this.allManager.map(b => {
              // console.log("CIP: ",b.posname.startsWith("CHIEF"))
              if (b.posname.startsWith("CHIEF")) {
                console.log("CIP: ", b.empname);
                this.adminValue.managerList.push(b);
                this.disablereport = false;
                this.emp.managerid = "";
              }
            });
          } else {
            this.adminValue.managerList = [];
            this.adminValue.managerList = this.allManager;
            this.disablereport = false;
            this.emp.managerid = "";
            // this.adminValue.managerList.pop();
          }
        }
      });
    },
    getStatList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/status").then(res => {
        console.log(res);
        if (!res.error) {
          this.adminValue.statList = res.message;
        } else {
        }
      });
    },
    getManagerList() {
      //get role list
      this.$http.get(":9992/api/v1/admin/user/managers").then(res => {
        // console.log(res);
        if (!res.error) {
          res.message.filter((a, i) => {
            console.log(a.posname);
            if (a.posname == "ALL") {
              this.sorokRoot = a;
              console.log([i]);
              res.message.splice(i, 1);
            }
          });
          this.allManager = res.message;
          console.log(res.message);
          this.adminValue.managerList = this.allManager;

          console.log(this.adminValue.managerList);
        } else {
        }
      });
    },
    getPostList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/position").then(res => {
        // console.log(res);
        if (!res.error) {
          this.adminValue.postList = res.message;
        } else {
        }
      });
    },
    getDeptList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/dept").then(res => {
        // console.log(res);
        if (!res.error) {
          this.adminValue.deptList = res.message;
        } else {
        }

        console.log(this.deptList);
      });
    },
    getRoleList() {
      //get role list
      this.$http.get(":9992/api/v1/admin/roles").then(res => {
        // console.log(res);
        if (!res.error) {
          this.adminValue.rolesList = res.message;
        } else {
        }
      });
    },
    deleteUser(id) {
      console.log("IDDEL: ", id);
      this.$http.delete(":9992/api/v1/admin/user/" + id).then(res => {
        console.log(res);
        if (!res.error) {
          console.log("delete");
        } else {
        }
      });
    },
    getAllUsers() {
      //get all users
      this.$http.get(":9992/api/v1/admin/user").then(res => {
        // console.log(res);
        this.allUsers = res.message;
        for (let i = 0; i < res.message.length; i++) {
          
          if (res.message[i].rolename == "ADMIN"){
            // console.log("BITCH: ",res.message[i].empid)
          }
          
          var obj = {
            employeeID: res.message[i].empid,
            name: res.message[i].empname,
            department: res.message[i].deptname,
            userRole: res.message[i].rolename,
            userReportedTo:
              res.message[i].managername == "ROOT"
                ? ""
                : res.message[i].managername,
            position: res.message[i].posname,
            accesslist: res.message[i].accesslist,
            loginstate: res.message[i].loginstate
          };
          this.tableData.push(obj);
        }
      });
      this.tableData = [];
    },
    submitUpdate(id) {
      console.log(id.employeeID);

      //  get role list
      let finaledata = {
        empname: this.emp.fname,
        emppassword: this.emp.passwd,
        empphone: "test123111",
        empaddr: "test123121212212",
        roleid: this.emp.roleid,
        posid: this.emp.posid,
        deptid: this.emp.deptid,
        statusid: this.emp.statid,
        managerid: this.emp.managerid,
        accessmodule: this.moduleaccess
      };
      console.log(finaledata);
      this.$http
        .put(":9992/api/v1/admin/user/" + id.employeeID, finaledata)
        .then(res => {
          console.log(res);
          if (!res.error) {
            swal({
              title: "Success!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
            this.getAllUsers();
            this.modals = false;
          } else {
            swal({
              title: "Error!",
              text: res.message,
              type: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        });
    },
    revokeSession(index, row) {
      console.log("REVOKING SESSION");
      console.log("INDEX", index);
      console.log("ROW", row);
      swal({
        title: "Are you sure to revoke login session for " + row.name + "?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn btn-default btn-fill",
        confirmButtonText: "Revoked it!!!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http.get(":9992/auth/staff/logout/"+row.employeeID).then(res => {
            console.log(res);
            if (res.error) {
              console.log(res.error)
              swal({
                text: `No session login session for  ${row.name}`,
                type: "error",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            } else {
              // this.getAllUsers()
              swal({
                text: `You revoked login session for  ${row.name}`,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            }
          });
        }
      });
    },
    handleEdit(index, row) {
      this.moduleaccess = [];
      console.log("INDEX", index);
      console.log("ROW", row);
      this.allUsers.map(x => {
        if (x.empid == row.employeeID) {
          this.emp.fname = x.empname;
          this.emp.empaddr = x.empaddr;
          this.emp.empphone = x.empphone;
          this.adminValue.rolesList.map(a => {
            if (a.RoleName == x.rolename) {
              this.emp.roleid = a.RoleID;
            }
          });
          this.adminValue.deptList.map(a => {
            if (a.DeptName == x.deptname) {
              this.emp.deptid = a.DeptID;
            }
          });
          this.adminValue.postList.map(a => {
            if (a.PosName == x.posname) {
              this.emp.posid = a.PosID;
              this.checkDisable();
            }
          });
          this.adminValue.statList.map(a => {
            if (a.StatusName == x.statusname) {
              this.emp.statid = a.StatusID;
            }
          });

          this.adminValue.managerList.map(a => {
            if (a.empname == x.managername) {
              this.emp.managerid = a.empid;
            }
          });

          //module
          let access = row.accesslist.split(",");

          access.map(a => {
            this.moduleaccess.push(parseInt(a));
          });
        }
      });
      console.log(this.allUsers);
      console.log(this.adminValue.managerList);
      console.log(this.emp.roleid);

      this.modals = true;
      this.currentRow = row;
    },
    handleDelete(index, row) {
      console.log(row);
      console.log(index);
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          this.deleteUser(row.employeeID);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    searchCustomer(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
</style>
